import classNames from 'classnames';
import { HTMLAttributeAnchorTarget } from 'react';
import AdminLink from '../../../../../types/AdminLink';
import { CurrentUserDto } from '../../../../../types/UserDtos';
import { ADMIN_BILLING, BASE } from '../../../../routes';
import { ThumbCard } from '../../../components/Cards';
import Ribbon from '../../../components/Cards/Ribbon';
import Link from '../../../components/Link';
import { hasBasicHr, isManager } from '../../../services/User';
import styles from './style.m.less';

function AdminLinkCompoundIcon({ icons }: { icons: string[] }) {
    const iconSrcs = icons.map(i => {
        try {
            return require(`./svg/${i}.svg`);
        } catch {
            return require(`./svg/default.svg`);
        }
    });

    return (
        <div className={styles.compoundIcon}>
            {iconSrcs.map(i => (
                <img key={i} className={styles.compoundIconImage} src={i} alt="" />
            ))}
        </div>
    );
}

function AdminLinkIcon({ icon }: { icon: string }) {
    let iconSrc = require(`./svg/default.svg`);
    try {
        iconSrc = require(`./svg/${icon}.svg`);
    } catch {
        // ignore error as we fall back to default svg
    }
    return <img className={styles.image} src={iconSrc} alt="" />;
}

type Props = AdminLink & {
    target?: HTMLAttributeAnchorTarget;
    currentUser?: CurrentUserDto;
};

export default function AdminLinkButton({
    name,
    url,
    tooltip,
    enabled,
    status,
    icon,
    className,
    target,
    currentUser = undefined,
}: Props) {
    const linkClasses = classNames(styles.card, className, {
        [styles.hasWarning]: status === 'WARNING',
        [styles.hasError]: status === 'ERROR',
    });

    const isBillingButton = url === BASE + ADMIN_BILLING;
    const showBuyRibbon = isBillingButton && currentUser && isUserToPurchase(currentUser);
    const card = (
        <ThumbCard isEnabled={enabled} className={linkClasses} isCompact={true}>
            {showBuyRibbon && <Ribbon text="Buy Here" color="BLUE" />}
            {Array.isArray(icon) && <AdminLinkCompoundIcon icons={icon} />}
            {!Array.isArray(icon) && <AdminLinkIcon icon={icon} />}
            <div>{name}</div>
        </ThumbCard>
    );

    return enabled ? (
        <Link href={url} className={styles.gridItem} hasTextStyle={false} data-tooltip={tooltip} target={target}>
            {card}
        </Link>
    ) : (
        <div className={styles.gridItem} data-tooltip={tooltip}>
            {card}
        </div>
    );
}

function isUserToPurchase(currentUser: CurrentUserDto) {
    if (currentUser) {
        const {
            company: {
                payment: { plan, userCount, freeLimit },
            },
        } = currentUser;

        return (hasBasicHr(currentUser) || isCEO(currentUser)) && plan === 0 && userCount > freeLimit;
    }
    return false;
}

function isCEO(user: CurrentUserDto) {
    return !user.isGuest && isManager(user) && !user.managerId;
}
